/** Deux rires quasi simultanés (écart strictement inférieur) → égalité. */
export const TIE_WINDOW_MS = 150;

export type Player = 'host' | 'guest';

/** Début du premier rire de chaque joueur, en horloge de l'hôte. */
export type Laughs = Readonly<Partial<Record<Player, number>>>;

/** Enregistre un rire ; en cas de doublon ou de désordre, le plus ancien fait foi. */
export function recordLaugh(laughs: Laughs, player: Player, t: number): Laughs {
  const previous = laughs[player];
  return previous !== undefined && previous <= t ? laughs : { ...laughs, [player]: t };
}

/** Le premier qui rit perd ; égalité si les deux rires sont à moins de `tieWindowMs`. */
export function arbitrate(
  laughs: Laughs,
  tieWindowMs = TIE_WINDOW_MS,
): 'hostLost' | 'guestLost' | 'tie' | null {
  const { host, guest } = laughs;
  if (host === undefined && guest === undefined) return null;
  if (guest === undefined) return 'hostLost';
  if (host === undefined) return 'guestLost';
  if (Math.abs(host - guest) < tieWindowMs) return 'tie';
  return host < guest ? 'hostLost' : 'guestLost';
}
